import { create } from 'zustand';

// Port of src/app/services/loader.service.ts.
interface LoaderState {
  isLoading: boolean;
  show: () => void;
  hide: () => void;
}

export const useLoaderStore = create<LoaderState>()((set) => ({
  isLoading: false,
  show: () => set({ isLoading: true }),
  hide: () => set({ isLoading: false }),
}));
